<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <fg-input :error="errorMessages.title" :max-length="modelSchema.title.maxLength" :required="modelSchema.title.required" v-model="model.title" :placeholder="'Name' | translate" :label="'Name' | translate"></fg-input>
      <fg-input  :error="errorMessages.name"  :max-length="modelSchema.name.maxLength" :required="modelSchema.name.required" v-model="model.name" :placeholder="'Slug' | translate" :label="'Slug' | translate"></fg-input>
      <div class="form-group has-label">
        <label class="control-label" v-translate>Description</label>
        <textarea :max-length="modelSchema.description.maxLength"
                  :required="modelSchema.description.required"
                  v-model="model.description"
                  class="form-control" :placeholder="'Description' | translate" rows="3"></textarea>
      </div>

      <div class="form-group has-label">
        <label class="control-label" v-translate>Show mode</label>
        <el-select class="select-success"
                   :placeholder="'Select show mode' | translate"
                   v-model="model.showMode">
          <el-option v-for="option in modelSchema.showMode.choices"
                     class="select-success"
                     :value="option.value"
                     :label="option.displayName"
                     :key="option.displayName">
          </el-option>
        </el-select>
      </div>

      <div class="form-group has-label">
        <label for="" class="control-label" v-translate>Statistics queries</label>
        <el-select
          v-model="model.sqlTemplatesIds"
          multiple
          filterable
          reserve-keyword
          @change="sqlTemplatesChange"
          :placeholder="'Select statistics queries' | translate">
          <el-option-group
            v-for="(group, title) in sqlTemplatesGroups"
            :key="title"
            :label="title">
            <el-option
              v-for="item in group"
              :key="item.id"
              :label="`${item.id}: ${item.description}`"
              :value="item.id">
            </el-option>
          </el-option-group>
        </el-select>
      </div>
      <p-checkbox v-model="model.forceStat"><span v-translate>Force update statistics</span></p-checkbox>

      <p-button type="info" round @click="save">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save and close</translate>
        <translate key="save" v-else>Add and close</translate>
      </p-button>

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'
  import { Card } from 'src/components/UIComponents'
  import {Select, Option, OptionGroup} from 'element-ui'

  export default {
    components: {
      Card,
      [Select.name]: Select,
      [OptionGroup.name]: OptionGroup,
      [Option.name]: Option
    },
    name: 'BrandForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'brands-index'
        }
      }
    },
    computed: {
      title () {
        if (this.isNew) {
          return this.$gettext('Add brand')
        } else {
          return this.$gettext('Edit brand')
        }
      },
      isNew () {
        return this.model.id === null
      }
    },
    created () {
      this.getSchema()

    },
    mounted () {
      if (this.$route.params.id && !this.model.id) {
        this.loadRecord(this.$route.params.id)
      }
    },
    data () {
      return {
        loading: false,
        sqlTemplatesLoading: false,
        sqlTemplatesGroups: [],
        sqlTemplates: [],
        showModes: [
          {'key': 'day_numbers', name: this.$gettext('Number of day')},
          {'key': 'dates', name: this.$gettext('Dates')},
          {'key': 'described', name: this.$gettext('Described')},
        ],
        errorMessages: {},
        schema: null,
        modelSchema: null,
        oldSqlTemplatesIds: new Set([9, 15]),
        model: {
          id: null,
          name: null,
          title: null,
          description: null,
          sqlTemplatesIds: [9, 15],
          forceStat: false,
          showMode: "day_numbers",
        }
      }
    },
    methods: {
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`expostat/brand/${id}/`)
        this.model = result.data
        this.oldSqlTemplatesIds = new Set(this.model.sqlTemplatesIds)
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = 'expostat/brand/'
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST

        // Загрузка шаблонов SQL
        const results = await this.$http.get('expostat/sql-template/')
        this.sqlTemplatesGroups = _.groupBy(results.data, group => group.name)
        this.sqlTemplates = _.keyBy(results.data, x => x.id)
      },
      async save () {
        this.loading = true
        const request = this.isNew ? this.$http.post('expostat/brand/', this.model) : this.$http.put(`expostat/brand/${this.model.id}/`, this.model)
        try {
          const result = await request
          this.model = result.data
          this.oldSqlTemplatesIds = new Set(this.model.sqlTemplatesIds)
          this.loading = false
          this.errorMessages = {}
          return true
        } catch (error) {
          this.errorMessages = _.mapValues(error.response.data, x => x.join(', '))
          this.loading = false
          return false
        }
      },
      async saveAndClose () {
        await this.save()
        this.$router.go(-1)
      },
      sqlTemplatesChange (_new) {
        // Получаем список изменений
        let changed = _new.filter(x => !this.oldSqlTemplatesIds.has(x))

        // Мапим шаблоны id: name
        const nameMappings = _.chain(this.sqlTemplates).keyBy('id').mapValues('name').value()
        // Получаем имена новых запросов
        const newNames = new Set(changed.map(x => nameMappings[x]))
        // Удаляем из старого списка запросы с таким же именем что и у новых
        const cleaned = _new.filter(x => !newNames.has(nameMappings[x]))
        // Объединяем результаты
        let filtered = [...cleaned, ...changed]
        // Обновляем значение модели
        this.model.sqlTemplatesIds = filtered
        this.oldSqlTemplatesIds = new Set(filtered)
      }
    }
  }
</script>

<style scoped>

</style>
